<template>
  <div
    :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }"
    class="content"
  >
    <QuizHeader :title="title" />
    <div v-if="leaderboard && leaderboard.length > 0">
      <div
        style="height: 200px;"
        :style="{
          backgroundColor: isDarkTheme ? topBgColor : bgTheme,
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px'
        }"
      ></div>
      <div
        class=""
        style="margin-right: 15px; margin-left: 15px; margin-top: -125px"
      >
        <div
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
          }"
          class="past-history-section common-section height-cus"
          style="overflow: hidden; border-radius: 10px; padding-bottom: 10px;"
        >
          <div
            class="past-history-title text-center"
            style="padding: 10px 0px;"
          >
            <span style="font-weight: 700; color: #323232;">Leaderboard</span>
          </div>

          <!-- Winner Section Start -->
          <div
            class="winner-section text-center"
            style="border-top: 1px solid #C8C8C8;"
            v-if="top_winners && top_winners.length >= 3"
          >
            <div class="title" style="margin-top: 10px;">
              <span style="font-weight: 700; color: #323232;">Winners</span>
            </div>

            <div
              class="row align-items-center"
              style="justify-content: center;"
            >
              <div class="col-3" style="max-width: 23%;">
                <div class="winner-block">
                  <img
                    src="@/assets/rank-2.svg"
                    alt="rank-2"
                    class="img-fluid"
                  />
                  <p style="color: #323232 !important; font-size: 14px;">
                    {{ top_winners[1].user_name }}
                  </p>
                </div>
              </div>
              <div class="col-2">
                <div class="winner-block first-rank">
                  <img
                    src="@/assets/rank-1.svg"
                    alt="rank-1"
                    class="img-fluid"
                  />
                  <p
                    style="color: #323232 !important; font-size: 15px; font-weight: 600;"
                  >
                    {{ top_winners[0].user_name }}
                  </p>
                </div>
              </div>
              <div class="col-3">
                <div class="winner-block">
                  <img
                    src="@/assets/rank-3.svg"
                    alt="rank-3"
                    class="img-fluid"
                  />
                  <p style="color: #323232 !important; font-size: 14px;">
                    {{ top_winners[2].user_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Winner Section End -->

          <!-- History Table Start -->
          <div
            class="history-table"
            style="border-top: 1px solid #C8C8C8; overflow: hidden;"
          >
            <!-- Vertical scroll container -->
            <div class="table-scroll">
              <table
                class="table table-borderless"
                style="width: 100%; table-layout: fixed; margin-bottom: 0;"
              >
                <thead>
                  <tr>
                    <th style="width: 20%; padding: 8px; color: #323232;">
                      Rank
                    </th>
                    <th style="width: 35%; padding: 8px; color: #323232;">
                      User
                    </th>
                    <th style="width: 22%; padding: 8px; color: #323232;">
                      Score
                    </th>
                    <th style="width: 23%; padding: 8px; color: #323232;">
                      {{ currency_label }}
                    </th>
                  </tr>
                </thead>

                <!-- Current user's rank -->
                <tbody>
                  <tr
                    v-if="user_data"
                    :style="{
                      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee'
                    }"
                    class="your-rank"
                  >
                    <td style="padding: 8px;">
                      {{ user_data.rank }}
                    </td>
                    <td
                      class="name"
                      style="padding: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                    >
                      {{ user_data.user_name }}
                    </td>
                    <td style="padding: 8px;">{{ user_data.score }}</td>
                    <td style="padding: 8px;">
                      {{ user_data.prize == 0 ? "0" : prize(user_data.prize) }}
                    </td>
                  </tr>
                </tbody>

                <!-- Leaderboard List -->
                <tbody
                  style="color: #544e4e;"
                  v-for="(item, index) in leaderboard"
                  :key="index"
                >
                  <tr>
                    <td style="padding: 8px;">{{ item.rank }}</td>
                    <td
                      class="name"
                      style="padding: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                    >
                      {{ item.user_name }}
                    </td>
                    <td style="padding: 8px;">{{ item.score }}</td>
                    <td style="padding: 8px;">
                      {{ item.prize == 0 ? "0" : prize(item.prize) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- History Table End -->
        </div>
      </div>
    </div>
    <div
      :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
      v-else
      class="height-90 border-radius-5 align-ver center-hor bg-light"
    >
      <div
        style="display: flex; justify-content: center; align-items: center; width: 100%"
      >
        <img src="@/assets/no-data.svg" class="w20" style="width: 25%;" />
      </div>
      <div style="font-weight: 800; font-size: 16px; margin-top: 20px;">
        {{ messsage }}
      </div>
    </div>
  </div>
</template>

<script>
import QuizHeader from "@/components/quiz-header";
import axios from "axios";
import { globals } from "@/mixins/globals";
export default {
  mixins: [globals],
  name: "PastHistory",
  components: {
    QuizHeader
  },
  data: () => ({
    id: null,
    title: null,
    top_winners: [],
    leaderboard: [],
    user_data: {},
    currency_label: "",
    messsage: ""
  }),

  methods: {
    fetchLeaderboard() {
      var self = this;
      var url = self.$store.getters.flyyDomain + "/leaderboard/" + self.id;
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            self.leaderboard = data.leaderboard;
            self.user_data = data.user_data;
            self.currency_label = data.currency_label;
            self.messsage = data.message;

            data.leaderboard.forEach((l, i) => {
              if (i <= 2) {
                self.top_winners.push(l);
              }
            });
          } else {
            console.log("Error fetching the Quiz list");
          }
        });
    },
    prize(itemVal) {
      if (typeof itemVal == "string") {
        var val = itemVal.toString().split(" - ");
        if (val.length > 0 && val[0] == val[1]) {
          return val[0];
        } else {
          return itemVal;
        }
      }

      if (typeof itemVal == "number") {
        return itemVal;
      }
    }
  },
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    offersCardBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    },
    topBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null;
    },
    mainBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null;
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.title = this.$route.params.title;
    console.log("Titile ---", this.title);
    this.fetchLeaderboard();
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.table-scroll {
  max-height: 350px; /* adjust as needed */
  overflow-y: auto; /* vertical scrolling */
  overflow-x: hidden; /* disable horizontal scrolling */
  width: 100%;
  -webkit-overflow-scrolling: touch; /* smooth scroll on iOS */
}

/* Scrollbar styling */
.table-scroll::-webkit-scrollbar {
  width: 4px;
}

.table-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .height-cus {
    min-height: 100vh;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .height-cus {
    height: 100vh;
  }
}
</style>
